export default __webpack_public_path__ + "static/media/Intero Real Estate Services.2615c9fd.jpg";